export const LIB_VERSION_CODE = 70815;
export const LIB_VERSION_NAME = "7.8.15";
